import React from 'react';
import { RichUtils } from 'draft-js';
import { eventNames } from '../../../../config';
import BaseGroupBlock from '../BaseGroupBlock';

const items = [
  { inlineStyle: 'header-one', tooltipTitle: 'Заголовок 1', children: 'H1' },
  { inlineStyle: 'header-two', tooltipTitle: 'Заголовок 2', children: 'H2' },
  { inlineStyle: 'header-three', tooltipTitle: 'Заголовок 3', children: 'H3' },
];
const isActive = (watchedValue, value) => watchedValue === value;
const HeadingGroupBlock = () => {
  return (
    <BaseGroupBlock
      items={items}
      evtName={eventNames.blockTypeChange}
      isActive={isActive}
      getNewState={RichUtils.toggleBlockType}
    />
  );
};

export default HeadingGroupBlock;
